export enum SidebarOption {
  USERS = 'Users',
  PAYMENTS = 'Invoice-Payment Status',
  SETTINGS = 'Settings',
  MY_GEM_VAULT = 'myGemVAULT™',
  MY_GEM_FAV = 'myGemFAV™',
  POROLIS_GEM_BANK = 'Porolis GemBANK™',
  VIEW_MY_GEM_VALUT = 'View myGemVAULT™',
  UPLOAD_A_PHOTO = 'Upload Gemstone',
  TERMS_AND_CONDITIONS = 'Terms & Conditions',
  MANAGE_SUBSCRIPTION = 'Manage Subscription',
  SUBORDINATES = 'Subordinates',
}
